import React from 'react'
import {Row, Col} from 'react-bootstrap'
import './style.css'

export default function comp_kategori() {
    return (
            <Row className="kategori">
                <Col md={6}>
                    <div className="cards-img">
                        <img src="asset/dashboard/kategori/kategori5.png" alt="kategori" />
                    </div>
                </Col>
                <Col md={6} >
                    {
                        KategComp.map((img, i) => {
                            return (
                                
                                <Row key={i} className="kategori comp-img">
                                    <Col>
                                        <img src={img.src} alt="kategori" />
                                    </Col>
                                </Row>
                            )
                        })
                    }
                </Col>
            </Row>
    )
}

const KategComp = [
    {src:"asset/dashboard/kategori/kategori6.png"},
    {src:"asset/dashboard/kategori/kategori7.png"}
]
